export const LIFECYCLE_OPTIONS = ['DRAFT', 'ACTIVE', 'IN_REVIEW', 'DEPRECATED', 'ARCHIVED'] as const
